<template>
  <el-date-picker
    style="width: 100%"
    type="date"
    v-model="date"
    value-format="yyyy-MM-dd"
    :placeholder="placeholder"
    @change="change"
  >
  </el-date-picker>
</template>

<script>
export default {
  model: {
    event: "change",
  },
  props: {
    value: String,
    column: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    value() {
      this.date = this.value;
    },
  },
  data() {
    return {
      date: this.value,
    };
  },
  computed: {
    placeholder() {
      return this.column.placeholder || "请输入" + this.column.name;
    },
  },
  methods: {
    change() {
      if (this.column.change && typeof this.column.change == "function") {
        this.column.change(this.date, this.column);
      }
      this.$emit("change", this.date, this.column);
    },
  },
};
</script>

<style></style>
